import React, {Component} from 'react';
import style from './MenuSide.module.scss';
import Close from "../../image/icon/cloose.png";
class MenuSide extends React.Component {
    constructor(props){
        super(props);
        this.state ={

        }
    }

    closeState=()=>{
        this.props.close();
    }
    render() {
        return (
            <div  className={this.props.menuState?style.MenuSide_show+" "+style.menu_container:style.MenuSide_hidden+" "+style.menu_container}>
            <div className={style.menu_container}>
                <ul>
                    <li>公司行业</li>
                    <li>关于</li>
                    <li>招聘</li>
                    <li>联系我们</li>
                </ul>
                <img src={Close} alt="" onClick={(e)=>this.closeState(e)}/>
            </div>
            </div>
        );
    }
}

export default MenuSide;